<template>
  <div
    v-if="isShowPage"
    class="index"
  >
    <van-nav-bar
      class="index-main-nav"
      :title="lang.memberCenter"
      :right-text="lang.logOut"
      :left-arrow="!$route.query.fromapp"
      @click-left="onClickLeft"
      @click-right="onLoginOut"
    />
    <section class="user">
      <router-link to="/edit-user/">
        <div class="user-img">
          <img
            v-if="userInfo.imagePath"
            :src="userInfo.imagePath | imgResize('user')"
            onerror="errorImg(this,'user')"
            alt
          >
          <img
            v-else
            src="//static.house730.com/m/images/user-default.png"
            onerror="errorImg(this,'user')"
            alt
          >
        </div>
        <div class="user-info">
          <div class="user-name">
            <b>{{ userInfo.nickName }}</b>
            <span>u{{ userInfo.userID }}</span>
          </div>
          <div class="user-email">
            {{ userInfo.email }}
          </div>
          <div class="user-now">
            {{ lang.coin }} : {{ userInfo.remainderPropertyCoin }}
          </div>
          <!-- <div class="user-now">{{lang.numberProperties}}{{userInfo.propertyNumber}}</div> -->
        </div>
        <div class="user-more">
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-gerenzhongxin-jiantoux" />
          </svg>
        </div>
      </router-link>
    </section>
    <section class="menu-list">
      <ul>
        <!-- to="/post/step1/" -->
        <li @click="goPost">
          <a>
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-residential" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.postProperty }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </a>
        </li>
        <li>
          <router-link to="/my-properties/">
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-myListings" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.editProperty }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/messages/">
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-guanliloupanwendax" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.manageMessages }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li> -->
        <li>
          <router-link to="/collection/">
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-myFavourites" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.myFavourites }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li>
        <!-- 楼盘订阅 -->
        <!-- <li>
          <router-link to="/subscribe/">
            <div class="left-icon">
              <img src="../assets/sub_index.png" alt="">
            </div>
            <span class="menu-list-name">{{ lang.subscribe }}</span>
            <div class="right-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li> -->

        <!-- <li>
          <router-link to="/history/">
            <div class="left-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-liulanjilux" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.browseHistory }}</span>
            <div class="right-icon">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li> -->
      </ul>
    </section>
    <section class="menu-list">
      <ul>
        <li @click="goEstatePrice">
          <a>
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-listingFees" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.propertyListings }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </a>
        </li>
        <li>
          <router-link to="/storedValueMoney/">
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-chuzhiwubix" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.hseMoneyTopUp }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/orders/">
            <div class="left-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-fukuanjilux" />
              </svg>
            </div>
            <span class="menu-list-name">{{ lang.purchaseHistory }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <section class="menu-list">
      <ul>
        <li>
          <a
            href="javascript:void(0);"
            @click="studyEntrance"
          >
            <div class="left-icon">
              <img
                src="../assets/study-icon@2x.png"
                alt=""
              >
            </div>
            <span class="menu-list-name">{{ lang.tutorial }}</span>
            <div class="right-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use xlink:href="#icon-gerenzhongxin-jiantoux" />
              </svg>
            </div>
          </a>
        </li>
      </ul>
    </section>
    <!-- 首次登录弹出框-->
    <firstLogin
      v-if="userInfo.remainderPropertyCoin"
      :coin-num="userInfo.remainderPropertyCoin"
    />
    <!-- 未设置邮箱弹出框 -->
    <!-- <van-popup class="set-email-index" v-model="showSetEmail">
      <p>{{ lang.setEmailNotice }}</p>
      <van-button type="primary" @click="$router.push('/edit-user/')">{{ lang.setNow }}</van-button>
    </van-popup> -->
  </div>
</template>
<script>
import pub from '../../common/public';
// import { NavBar, Icon, Cell, CellGroup } from 'vant';
import lang from './../../common/language/index';
import '../../common/css/common.scss';
import firstLogin from '@/components/first-login';
const _conf = require('../../common/js/_conf');
export default {
  metaInfo: { title: lang.memberCenter },
  name: 'Index',
  components: {
    firstLogin
    // [NavBar.name]: NavBar,
    // [Icon.name]: Icon,
    // [Cell.name]: Cell,
    // [CellGroup.name]: CellGroup
  },
  data() {
    return {
      isShowPage: false,
      // showSetEmail: false,
      lang: lang,
      userInfo: {
        userID: '',
        contactNameCN: '',
        email: '',
        telephone: '',
        imagePath: ''
      },
      isPc: false,
      existingHse: ''
    };
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    // this.isPc = document.body.clientWidth >= 750;
    console.log("userAgent",navigator.userAgent.toLowerCase())
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcPassport}zh-cn/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcPassport}en-us/`;
      } else {
        location.href = `${pub.config.pcPassport}`;
      }
    } else {
      this.isShowPage = true;
    }
    /**获取用户信息 */
    this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
      if (res.data.code == 0 && res.data.result) {
        this.userInfo = res.data.result;
      } else if (res.data.code == 101) {
        this.onLoginOut();
      }
    });
    this.imagePth='https://img.house730.com/2022/11/28/f0e8d7ca62f64d94bcfbbcc8753c13c1.png'
  },
  methods: {
    studyEntrance () {
      window.location.href = 'https://promotion.house730.com/tutorial/'
    },
    /**跳转放盘 */
    goPost() {
      // if (!this.userInfo.email) this.showSetEmail = true;
      this.$router.push('/post/');
    },
    /**跳转刊登楼盘价格 */
    goEstatePrice() {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com' : _conf.env_type == 3 ? 'https://www.house730.com' : 'https://uat.house730.com.cn';
      if (document.URL.indexOf('en-us') > -1) {
        location.href = `${base}/en-us/help/charge/`;
      } else if (document.URL.indexOf('zh-cn') > -1) {
        location.href = `${base}/zh-cn/help/charge/`;
      } else {
        location.href = `${base}/help/charge/`;
      }
    },

    onClickLeft() {
      /**获取当前语言 */
      let language = this.pub.getLang();
      /**跳转到主页面 */
      const host = location.origin + '/' + (language == 'zh-hk' ? '' : language);
      window.location.href = host;
    },
    onLoginOut() {
      this.pub.delCookie('ERnJaMWtkM');
      this.pub.delCookie('cEVaUDFrZ1kd0RA');
      /**点退出登陆后清除本地cookie 点击跳转到官网首页 */
      let language = this.pub.getLang();
      let url = language === 'zh-cn' ? 'zh-cn/' : language === 'en-us' ? 'en-us/' : '';
      location.href = this.pub.config.wapUrl + url;
      //点退出登陆后清除本地cookie, 无条件转向登录页
      // this.$router.push('/login/');
    }
  }
  // beforeRouteLeave(to, from, next) {
  //   if (to.name === 'post') {
  //     to.meta.keepAlive = false; // 让 post 不缓存，即刷新
  //     this.store.commit('clearStore');
  //   }
  //   next();
  // }
};
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}
.font12 {
  font-size: 12px;
}
.index {
  width: 100%;
  height: 100%;
  text-align: left;
  background-color: #f5f6f7;
  .index-main-nav {
    .van-nav-bar__text {
      color: #333;
    }
  }
  .set-email-index.van-popup {
    text-align: center;
    border-radius: 4px;
    box-sizing: border-box;
    width: 70%;
    padding: 24px;
    p {
      color: #333;
      font-size: 15px;
      line-height: 21px;
      margin: 12px 0 24px;
    }
    .van-button {
      width: 160px;
      height: 40px;
      line-height: 40px;
      background-color: #ed1c24;
      border: #ed1c24;
      font-size: 15px;
    }
  }
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
.van-nav-bar__text {
  color: #ed1c24;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.user {
  a {
    display: block;
    height: 108px;
    color: #333;
    display: flex;
  }
  position: relative;
  margin-top: 14px;
  height: 108px;
  width: 100%;
  background-color: #fff;
  .user-img {
    width: 92px;
    img {
      // background-image: url('//static.house730.com/m/images/user-default.png');
      background-size: 60px 60px;
      margin-left: 16px;
      display: block;
      height: 60px;
      width: 60px;
      border-radius: 2px;
      margin-top: 24px;
      background-color: #eee;
    }
  }
  .user-info {
    flex: 1;
    margin-top: 30px;
    text-align: left;
    color: #333;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .user-name {
      width: calc(100% - 32px);
      margin-bottom: 6px;
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      b {
        max-width: calc(100% - 50px);
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        padding-left: 4px;
        font-size: 12px;
      }
    }
    .user-email {
      font-size: 12px;
      margin-bottom: 8px;
      color: #666;
    }
    .user-now {
      font-size: 12px;
      margin-bottom: 8px;
      color: #666;
      line-height: 18px;
    }
  }
  .user-more {
    position: absolute;
    right: 20px;
    top: 46px;
    .van-icon {
      font-size: 20px;
    }
  }
}
.menu-list {
  margin-top: 14px;
  background-color: #fff;
  text-align: left;
  ul {
    li {
      height: 44px;
      padding-left: 15px;
    }
    li:active {
      background-color: #eee;
    }
    li:last-child a {
      border-bottom: 1px solid transparent;
    }
    a {
      height: 44px;
      padding: 12px 15px 10px 0;
      box-sizing: border-box;
      color: #333;
      display: block;
      line-height: 22px;
      border-bottom: 1px solid #eee;
      .left-icon {
        float: left;
        width: 16px;
        i {
          color: #ed1c24;
        }
        img {
          width: 16px;
          height: 16px;
          padding-top: 3px;
        }
      }
      .right-icon {
        float: right;
        i {
          margin-top: 2px;
          color: #b2b2b2;
        }
      }
      .menu-list-name {
        display: inline-block;
        padding-left: 15px;
        font-size: 15px;
        line-height: 22px;
      }
      .menu-list-num {
        display: inline-block;
        float: right;
        font-size: 15px;
        color: #999;
      }
    }
  }
}
</style>
